module.exports = __webpack_public_path__ + "img/33.5a9cc0e8.5a9cc0e8.svg";